import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import type { tPasteTruncatedWarningProps } from './FieldCharCounter.types';

export default function PasteTruncatedWarning(props: tPasteTruncatedWarningProps) {
  const { t } = useTranslation('common/fieldCharCounter');
  if (!props.visible) return null;
  return (
    <p
      role="status"
      className={classnames('text-xs text-warning mt-1', props.className)}
    >
      {t('pasteTruncated', { max: props.max.toLocaleString() })}
    </p>
  );
}
